// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "2021c32-dirty",
    "hash": "2021c32",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "2021c32-dirty",
    "semverString": null,
    "version": "2.0.36"
};
/* tslint:enable */
